<template>
  <div id="home-page"  class="pageContainer">
    <div class='wall'></div>
    <div class="greeting-container">
       <div class="greeter" style='margin-top:2em;'>
        <span class="type-simulator sentence">Hi...</span>
      </div>
      <div class="greeter">
        <router-link  to="/contact" class="type-simulator sentence">Lets connect.</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import BaseView from '@/components/BaseView'
import Component from 'vue-class-component'
import {prepareTypingEffect} from '@/ui/UIUtil.js'


@Component({
  components: {
//    MainGallery
  }
})
export default class Home  extends BaseView{

  mounted(){
    this.$el.querySelectorAll(".type-simulator").forEach(function( el ){
        const val = el.innerHTML;
        el.innerHTML = "";
        prepareTypingEffect( el, val );
    }.bind(this));
    setTimeout( function(){
      this.$el.classList.add("active");
    }.bind(this), 10 );

    var arr = [];
    this.$el.querySelectorAll(".type-simulator").forEach(
      function( el ) {
         arr.push( el );
      }.bind(this));

    setTimeout( function(){
      this.enableSentences( arr );
    }.bind(this), 500);


  }

  enableSentences( arr ) {
    const el = arr.shift();
    el.classList.add('active');
    if( arr.length > 0 ) {
      setTimeout( function(){
        this.enableSentences( arr );
      }.bind(this), 2000);
    }

  }

  beforeDestroy(){
    console.log('home beforeDestroy ')
    
  }

}
</script>


<style lang="scss">
 #home-page{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  .sentence{
    color: var(--basecolor);
    font-size: 20pt;
  }
  a.sentence,
  a.sentence:visited{
    text-decoration: underline;

  }

  .greeting-container{
    margin-top: 20vh;
  }

  div.wall {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    background-image: url( ../assets/images/walking_on_container.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: right bottom;
    transform: translateY(10px);
    opacity: 0;
    transition: all 1s ease-in-out;     
  }
  .greeter{
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.75s cubic-bezier(1,.72,.76,.98) 0.2s;  
  }

  &.active{
    .wall{
      opacity: 1;
      transform: translateY(0px);
    }
    .greeter{
      opacity: 1;
      transition: all 0.75s cubic-bezier(1,.72,.76,.98) 0.5s;     
      transform: translateY(0px);
    }
  }
 }

</style>